'use client';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  background-color: transparent;
  margin: ${({ theme }) => theme.spacing(8, 0, 12, 0)};
  gap: ${({ theme }) => theme.spacing(1)};
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(0, 8, 0, 8)};
  @media ${({ theme }) => theme.tablet} {
    margin-left: auto;
    margin-right: auto;
    width: 480px;
  }
`;

export const RadioCellContainer = styled.div`
  fieldSet {
    padding: 0;
  }
`;

export const WeightInputContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Label = styled.label`
  ${({ theme }) => theme.typography.body};
  color: ${({ theme }) => theme.colors.text.secondary};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  display: inline-block;
`;

export const GridWrapper = styled.div`
  div {
    background-color: ${({ theme }) => theme.colors.background.lightest};
  }
`;

export const StyledPupForm = styled.form`
  width: 100%;

  @media ${({ theme }) => theme.tabletL} {
    max-width: 640px;
  }
`;

export const Footnote = styled.div`
  color: ${({ theme }) => theme.colors.border.fur};
  ${({ theme }) => theme.typography.body};

  margin-top: ${({ theme }) => theme.spacing(2)};
`;
